// NavButton is used in Header.js and Landing.js for website navigation

import { Link } from "react-router-dom";

function NavButton({url, value}) {
    return (
        <Link to={url} class='link'>
            <button>{value}</button>
        </Link>
    );
}

export default NavButton;